// @ts-check
import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

import LeaderImage from 'images/characters/leader.svg';
import styled from 'styled-components';
import { LBButton } from '@linearb/buzz';

const StyledSVG = styled.img`
  width: 15rem;
  height: 12rem;
`;

const ProjectManagementRetirementTab = ({
  routeToCustomPmMetrics = _.noop
}) => {
  return (
    <Flex
      direction='column'
      width='23rem'
      pt='normal'
      pb='normal'
      pl='medium'
      pr='small'
      items='center'
    >
      <StyledSVG src={LeaderImage} alt='Connect to Slack' />
      <Flex items='start' direction='column'>
        <Text mt='1rem' weight='500' lineHeight='150%' size='x-medium'>
          New dashboard incoming!
        </Text>

        <Text
          mt='1rem'
          color='shuttleGray'
          size='x-medium'
          letterSpacing='0.2px'
          lineHeight='150%'
        >
          Project Management is being replaced with new and improved content and
          functionality.
        </Text>
        <Text
          mt='1rem'
          mb='1rem'
          letterSpacing='0.2px'
          color='shuttleGray'
          lineHeight='150%'
          size='x-medium'
        >
          Check out all of that good stuff in:
        </Text>
        <LBButton onClick={routeToCustomPmMetrics}>Custom PM Metrics</LBButton>
      </Flex>
    </Flex>
  );
};

export default ProjectManagementRetirementTab;
